/* eslint-disable jsx-a11y/anchor-is-valid */
import { IonItem, IonToast } from '@ionic/react';
import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query';
import { User } from 'model';
import { useState } from 'react';
import { useHistory } from 'react-router';
import { Virtuoso } from 'react-virtuoso';
import { useLazySearchUserQuery } from '../../api/UserApi';
import { SearchBar } from '../../components/Forms/SearchBar';
import { Header } from '../../components/Header';
import { IconButton } from '../../components/IconButton';
import { NoResults } from '../../components/NoResults';
import { IconArrowBack, IconSearch } from '../../components/QuirkIcons';
import { QuirkIonContent } from '../../components/QuirkIonContent';
import { QuirkIonPage } from '../../components/QuirkIonPage';
import { QuirkLoader } from '../../components/QuirkLoader';
import { UserItem } from '../../components/admin/UserItem';
import { useQueryWithDebounce } from '../../hooks/useQueryWithDebounce';
// eslint-disable-next-line css-modules/no-unused-class
import sharedStyles from '../../styles/Shared.module.css';
export const AdminUserSearch = () => {
	const [search, setSearch] = useState('');

	const {
		trigger,
		data: searchedUsers,
		isFetching,
		isLoading,
		isError,
		error
	} = useQueryWithDebounce(useLazySearchUserQuery, 100);
	const history = useHistory();

	return (
		<QuirkIonPage name="Admin User Search">
			<Header
				title="Search users"
				left={
					<IconButton
						icon={<IconArrowBack />}
						onClick={() => {
							history.go(-1);
						}}
					/>
				}
			/>

			<QuirkIonContent scroll={false}>
				<>
					<div className={sharedStyles.contentWrapper}>
						<SearchBar
							placeholder="Search Users"
							value={search}
							onChangeAction={event => {
								setSearch(event.detail.value as string);
								trigger(event.detail.value ? event.detail.value : '');
							}}
							isFetching={isFetching}
							isLoading={isLoading}
						/>
					</div>
					<QuirkLoader
						isLoading={isLoading}
						loadingMessage="Loading users..."
						data={searchedUsers}
						noResults={
							<NoResults
								heading="No users found."
								subheading="Refine or clear your search filters."
								icon={<IconSearch />}
							/>
						}
					>
						<Virtuoso
							style={{ height: '100%' }}
							totalCount={searchedUsers?.length}
							data={searchedUsers}
							itemContent={(index, user: User) => {
								return (
									<IonItem className={sharedStyles.ionItem}>
										<UserItem user={user} />
									</IonItem>
								);
							}}
						/>
					</QuirkLoader>
				</>
			</QuirkIonContent>

			<IonToast
				isOpen={isError}
				duration={1500}
				message={((error as FetchBaseQueryError)?.data as any)?.error}
				position="top"
				color="danger"
			/>
		</QuirkIonPage>
	);
};
